import { LANGUAGE_FIELDS } from '@client/feature/activeSubstance/config/filterConfigs';

/**
 * Configuration for treatment search steps
 */
export const SEARCH_STEPS = [
  {
    key: 1,
    title: 'steps.culture.title',
    label: 'steps.culture.label',
    description: 'steps.culture.description',
    placeholder: 'steps.culture.placeholder',
    field: 'treatment_cultures.culture',
    document: 'TreatmentDocument',
    label_field: 'french_name',
    value_field: 'id',
    languageConfig: LANGUAGE_FIELDS.cultures,
    autoProgress: true,
    required: true,
  },
  {
    key: 2,
    title: 'steps.culture_practice.title',
    description: 'steps.culture_practice.description',
    placeholder: 'steps.culture_practice.placeholder',
    field: 'treatment_cultures.cultural_practices',
    document: 'TreatmentDocument',
    value_field: 'id',
    label_field: 'name',
    autoProgress: true,
    required: true,
  },
  {
    key: 3,
    title: 'steps.treatment_type.title',
    description: 'steps.treatment_type.description',
    field: 'treatment_type',
    placeholder: 'steps.treatment_type.placeholder',
    document: 'TreatmentDocument',
    value_field: 'id',
    label_field: 'name',
    autoProgress: true,
    required: true,
  },
  {
    key: 4,
    title: 'steps.application_type.title',
    description: 'steps.application_type.description',
    field: 'application_type',
    placeholder: 'steps.application_type.placeholder',
    document: 'TreatmentDocument',
    value_field: 'id',
    label_field: 'name',
    autoProgress: true,
    required: true,
  },
  {
    key: 5,
    title: 'steps.intervention_period.title',
    description: 'steps.intervention_period.description',
    field: 'intervention_period',
    placeholder: 'steps.intervention_period.placeholder',
    document: 'TreatmentDocument',
    value_field: 'id',
    // SP-430 R63: filter shows « Période d'intervention sur la culture » (name);
    // « Pour affichage client » (display_name) is kept for the results table.
    label_field: 'name',
    // SP-430 R65: order intervention periods by the Admin display order (priority),
    // not alphabetically.
    sortSourceField: 'intervention_period.priority',
    autoProgress: false,
    required: (selections) => {
      const treatmentTypeLabels = selections?._labels?.['treatment_type'] || [];
      const test = treatmentTypeLabels.some((item) => {
        const label = (item.label || item.name || '').toLowerCase();
        return (
          label.includes('herbicide') ||
          label.includes('défanants et aides à la récolte')
        );
      });
      return test;
    },
  },
];

export const STEP_STATUS = {
  COMPLETED: 'completed',
  ACTIVE: 'active',
  AVAILABLE: 'available',
  DISABLED: 'disabled',
};

export const AUTO_PROGRESS_DELAY = 200;
export const MIN_STEPS_FOR_SEARCH = 2;
